import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FacebookModule } from 'ngx-facebook';
import { FbShareComponent } from './components/fb-share/fb-share.component';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    FacebookModule,
    SharedModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [FbShareComponent],
  exports: [FbShareComponent]
})
export class FbShareModule { }
